/*
 * A short notice at the bottom of the screen that outlives whatever opened it (Send feedback closes at once and
 * says so here). Plain DOM: no provider, any code can call it. One at a time.
 */
let current: HTMLElement | null = null;

export function showToast(text: string, ms = 3500): void {
  current?.remove();
  const el = document.createElement("div");
  el.className = "toast";
  el.setAttribute("role", "status");
  el.textContent = text;
  document.body.append(el);
  current = el;
  setTimeout(() => {
    el.classList.add("leaving");
    setTimeout(() => {
      el.remove();
      if (current === el) current = null;
    }, 250);
  }, ms);
}
